module.exports = __webpack_public_path__ + "static/media/code.79ce091f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/code.svg
// module id = 1054
// module chunks = 3